export default __webpack_public_path__ + "static/media/wifi-signal.3baaaae1.svg";